export default function Logo() {
  return null
}
